import apigClientFactory from 'aws-api-gateway-client'
import { apigRegion, apigBaseUrl } from '../constants/amazon'


let apigClient = null

export default function invoke (method, pathTemplate, params, data) {
  if (apigClient === null) {
    const AWS = window.AWS
    apigClient = apigClientFactory.newClient({
      accessKey: AWS.config.credentials.accessKeyId,
      secretKey: AWS.config.credentials.secretAccessKey,
      sessionToken: AWS.config.credentials.sessionToken,
      region: apigRegion,
      invokeUrl: apigBaseUrl
    })
  }

  let body = null
  if (method === 'PUT' || method === 'POST') {
    body = data
  }

  console.log('Invoking api at ' + pathTemplate)
  return apigClient.invokeApi(params, pathTemplate, method, {}, body)
}
